export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-star-line',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-3-line',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-shopping-bag-3-line',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-arrow-left-right-line',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
  },
];

export const faqs = [
  {
    question: 'What is Vigorbuy Spreadsheet?',
    answer: 'Vigorbuy Spreadsheet is a structured product discovery system that organizes thousands of products into easy-to-navigate categories. It helps shoppers quickly find sneakers, clothing, accessories, and more through organized links, product images, and quality reference information — all in one centralized database.',
  },
  {
    question: 'Is Vigorbuy Spreadsheet free to use?',
    answer: 'Yes, the Vigorbuy Spreadsheet is completely free to browse and explore. You can access all product categories, compare items across different styles, and use the organized links without any subscription or payment required. Simply choose your category and start discovering products.',
  },
  {
    question: 'How often is the Vigorbuy Spreadsheet updated?',
    answer: 'The Vigorbuy Spreadsheet is updated regularly with new product links, refreshed category listings, and the latest finds. The team behind the spreadsheet continuously adds trending items and removes outdated links to ensure you always have access to current, working product references.',
  },
  {
    question: 'How do I use the Vigorbuy Spreadsheet?',
    answer: 'Using the Vigorbuy Spreadsheet is straightforward. Start by selecting a product category from the dropdown menu or category cards on this page. Browse through the organized product links for that category. Review product details and quality information. When you find something you like, follow the link to continue shopping on the main platform.',
  },
  {
    question: 'Is Vigorbuy Spreadsheet safe to use?',
    answer: 'The Vigorbuy Spreadsheet is designed as an informational resource that organizes and presents product links. We recommend always verifying the destination website before making any purchase, avoiding sharing unnecessary personal information, and comparing products across multiple sources. The spreadsheet itself is a discovery tool — actual transactions happen on external platforms.',
  },
  {
    question: 'What product categories are available in the spreadsheet?',
    answer: 'The Vigorbuy Spreadsheet covers a wide range of categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and more. Each category contains organized product links with detailed information to help you make informed shopping decisions.',
  },
  {
    question: 'Can I find budget-friendly products in the spreadsheet?',
    answer: 'Absolutely. The Vigorbuy Spreadsheet includes products across various price ranges — from affordable everyday items to premium selections. The organized structure makes it easy to compare similar products and find options that fit your budget while maintaining quality standards.',
  },
  {
    question: 'Do I need an account to access Vigorbuy Spreadsheet?',
    answer: 'No account or registration is required. The Vigorbuy Spreadsheet is openly accessible to everyone. Simply visit this website, browse the categories, and follow the links to discover products. There are no sign-up forms, no login requirements, and no hidden barriers between you and the product database.',
  },
];

export const whyChooseFeatures = [
  {
    feature: 'Product Discovery',
    normal: 'Slow manual browsing',
    spreadsheet: 'Organized database with instant access',
  },
  {
    feature: 'Product Categories',
    normal: 'Limited filtering options',
    spreadsheet: '14+ organized categories covering all styles',
  },
  {
    feature: 'Quality Information',
    normal: 'Hard to find and verify',
    spreadsheet: 'Easy side-by-side comparison',
  },
  {
    feature: 'Beginner Experience',
    normal: 'Complex and overwhelming',
    spreadsheet: 'Step-by-step guides for newcomers',
  },
  {
    feature: 'Time Efficiency',
    normal: 'Hours of scattered searching',
    spreadsheet: 'Find products in minutes',
  },
  {
    feature: 'Updates',
    normal: 'Static and outdated listings',
    spreadsheet: 'Regularly refreshed with new finds',
  },
];

export const howItWorks = [
  {
    step: '01',
    title: 'Choose Your Category',
    description: 'Select from 14+ product categories including Shoes, Hoodies, Jackets, Accessories, and more. Each category is organized for quick navigation.',
  },
  {
    step: '02',
    title: 'Browse & Compare Products',
    description: 'Explore organized product links within your chosen category. Compare items side by side with detailed information and quality references.',
  },
  {
    step: '03',
    title: 'Review Quality Details',
    description: 'Check product images, quality references, and detailed information to make informed decisions before purchasing.',
  },
  {
    step: '04',
    title: 'Continue to Main Platform',
    description: 'Once you find what you are looking for, follow the link to the main platform to complete your shopping journey.',
  },
];

export const safetyTips = [
  {
    check: 'Website Verification',
    recommendation: 'Always verify you are on the correct destination website before proceeding with any purchase. Cross-reference links when possible.',
  },
  {
    check: 'Privacy Protection',
    recommendation: 'Avoid sharing unnecessary personal information. Only provide what is required for completing a legitimate transaction.',
  },
  {
    check: 'Product Research',
    recommendation: 'Compare products across multiple categories and sources before making a final purchasing decision.',
  },
  {
    check: 'Secure Browsing',
    recommendation: 'Ensure your connection is secure (HTTPS) when visiting external websites. Look for the padlock icon in your browser address bar.',
  },
  {
    check: 'Independent Resource',
    recommendation: 'Vigorbuy Spreadsheet is an independent informational resource. We organize product links but do not process transactions directly.',
  },
];